import Fa from "./fa/label.js";
import En from "./en/label.js";

let language = localStorage.getItem("selectedLanguage");
let label;
if (language && language === "En") {
  label = En;
}
else {
  label = Fa;
}

export default label;
